import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      color: COLORS.gray.gray40,
      padding: theme.spacing(0.75),

      '&$horizontal': {
        '& svg': {
          transform: 'rotate(90deg)',
        },
      },
      '&$small': {
        padding: theme.spacing(0.5),
        '& svg': {
          fontSize: theme.typography.pxToRem(20),
        },
      },

      '&:hover': {
        color: COLORS.primary.default,
        backgroundColor: 'transparent',
      },
    },
    horizontal: {},
    small: {},
    title: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(1, 2),
      backgroundColor: COLORS.gray.gray90,
      borderBottom: theme.shape.borderGray70,
      fontSize: theme.typography.pxToRem(11),
      lineHeight: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightMedium,
      color: COLORS.gray.black,

      // We want the "header" to also fill the width of the parent container
      margin: theme.spacing(-1, -1, 1),
    },
    menuRoot: {
      marginTop: theme.spacing(0.5),
    },
    buttonClose: {
      ...theme.typography.medium12,
      position: 'absolute',
      top: 0,
      right: theme.spacing(1),
      padding: theme.spacing(1),
      height: 'auto',
    },
  }),
  { name: 'ContextMenu' }
);
